/**
 * @module TypeSearch
 * @author Created by yanghongmei1
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import { JDDevice, JDImage, JDText, JDTouchableWithoutFeedback } from '@jdreact/jdreact-core-lib';

import { pt } from '../../../../components/utiles';

export default class TypeSearch extends PureComponent {
    static defaultProps = {
        name: 'TypeSearch',
        title: '',
        list: [],
        searchObj: {},
        customStyle: {},
        talkParams: () => {} // 第一个参数是选择的list,第二个参数是传递过来的tabIndex(当前组件在大搜索中的index)没有就不回传
    }

    constructor(props) {
        super(props);
        this.state = {
            myChooseShare: this.props.searchObj.houseType == 3,
            myList: this.props.list,
            // myListS: this.props.list[2].secondLabel,
            myListS: [],
            searchObj: this.props.searchObj
        };
        this._selectItem = this._selectItem.bind(this);
    }

    render() {
        const {
            customStyle,
        } = this.props;
        const { myList, myListS, myChooseShare } = this.state;
        return (
            <View style={styles.m_container}>
                <View style={styles.m_content}>
                    <View style={styles.m_contentInner}>
                        {myList.length > 0 && myList.map((item, index) => {
                            return (
                                index < 2 ? <JDTouchableWithoutFeedback
                                    contentContainerStyle={styles.m_itemBoxView}
                                    key={item.id + '_box'}
                                    style={[customStyle, styles.m_itemBoxView]}
                                    onPress={() => this._selectItem(item, index)}>
                                    <View style={[customStyle, styles.m_itemBox, item.selected && styles.m_itemBoxChoosed]} key={item.id}>
                                        {item.icon ? <JDImage style={styles.m_icon} source={item.icon} resizeMode='contain' /> : null}
                                        {item.name && <JDText
                                            style={[styles.m_itemText, item.selected && styles.m_itemTextChoosed, item.disabled && styles.m_disabled]}
                                        >
                                            {item.name}
                                        </JDText>}
                                    </View>
                                </JDTouchableWithoutFeedback> : null
                            );
                        })}
                    </View>
                    {/* {myChooseShare && <View style={styles.titleBox}><JDText style={styles.titleText}>{'共享办公类型'}</JDText></View>}
                    {myChooseShare ? <View style={styles.m_contentInner}>
                        {myListS.length > 0 && myListS.map((item, index) => {
                            return (
                                <TouchableOpacity
                                    key={item.id + '_box'}
                                    style={[customStyle, styles.m_itemBoxView]}
                                    onPress={() => this._selectItemS(item, index)}>
                                    <View style={[customStyle, styles.m_itemBox, item.selected && styles.m_itemBoxChoosed]} key={item.id}>
                                        {item.icon ? <JDImage style={styles.m_icon} source={item.icon} resizeMode='contain' /> : null}
                                        {item.name && <JDText
                                            style={[styles.m_itemText, item.selected && styles.m_itemTextChoosed, item.disabled && styles.m_disabled]}
                                        >
                                            {item.name}
                                        </JDText>}
                                    </View>
                                </TouchableOpacity>
                            );
                        })}
                    </View> : null} */}
                </View>
            </View>
        );
    }

    componentDidMount() {
        try {    
            const { searchObj, list } = this.props;
            if ( list.length < 1 ) {
                return
            }
            let List = [
                {
                    id: list[0].id,
                    name: list[0].name,
                    selected: false
                },{
                    id: list[1].id,
                    name: list[1].name,
                    selected: false
                },{
                    id: list[2].id,
                    name: list[2].name,
                    selected: false
                }]
            const pramsString = searchObj.subHouseType
            // const listS = list[2].secondLabel
            const listS = []
            if (false && pramsString && listS && listS.length > 0) {
                const paramsList = pramsString.split(',');
                let List_s = JSON.parse(JSON.stringify(listS));
                for (let i = 0; i < paramsList.length; i++) {
                    for (let j = 0; j < List_s.length; j++) {
                        if (paramsList[i] == List_s[j].id) {
                            List_s[j].selected = true;
                            break;
                        }
                    }
                }
                List[2].selected = true
                this.setState({
                    myList: List,
                    myListS: List_s
                });
            } else if(!searchObj.houseType){
                this.setState({
                    myList: List,
                    myListS: listS
                });
            } else {
                const chooseId = searchObj.houseType
                for (let i = 0; i < List.length; i++) {
                    if (List[i].id == chooseId) {
                        List[i].selected = true;
                    }
                }
                this.setState({
                    myList: List,
                    myListS: listS
                });
            }
        } catch (err) {
            console.log(err)
        }
    }

    _selectItem(item, index) {
        if (item.disabled) {
            return;
        }
        const { myList } = this.state;
        const List = JSON.parse(JSON.stringify(myList));
        const length = List.length;
        const isChooseShare = index === 2 && !item.selected
        // 单选
        List[index].selected = !item.selected;
        for (let i = 0; i < length; i++) {
            if (i !== index) {
                List[i].selected = false;
            }
        }
        this.setState({
            myList: List,
            myChooseShare: isChooseShare
        });
    }

    _selectItemS = (item, index) => {
        // if (item.disabled) {
        //     return;
        // }
        // const { myListS } = this.state;
        // const List = JSON.parse(JSON.stringify(myListS));
        // List[index].selected = !item.selected;
        // this.setState({
        //     myListS: List
        // });
    }

    _resetClick = () => {
        const { list } = this.props;
        this.setState({
            myList: list,
            // myListS: list[2].secondLabel,
            myListS: [],
            myChooseShare: false
        });
    }

    _AllOkClick = () => {
        const { myList, myListS } = this.state;
        let params = {subHouseType:'', houseType:''};
        for (let i = 0; i < myList.length; i++) {
            if (myList[i].selected) {
                params.houseType = myList[i].id
            }
        }
        // if (params.houseType && params.houseType == 3) {
        //     let ids = ''
        //     for (let j = 0; j < myListS.length; j++) {
        //         if (myListS[j].selected) {
        //             ids = ids === '' ? myListS[j].id + '' : (ids + ',' + myListS[j].id);
        //         }
        //     }
        //     params.subHouseType = ids
        // }
        this.props.talkParams(params);
    }
}

TypeSearch.propTypes = {
    name: PropTypes.string,
    title: PropTypes.string,
    list: PropTypes.array,
    searchObj: PropTypes.object,
    customStyle: PropTypes.any,
    talkParams: PropTypes.func
};

const styles = StyleSheet.create({
    m_container: {
    },
    m_content: {
        marginLeft: -pt(24)
    },
    m_contentInner: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'flex-start'
    },
    m_itemBoxView: {
        flexDirection: 'row',
        height: pt(64),
        alignItems: 'center',
        marginLeft: pt(24),
        marginBottom: pt(24)
    },
    m_itemBox: {
        flexDirection: 'row',
        borderColor: '#F6F6F6',
        borderWidth: JDDevice.getDpx(3),
        height: pt(64),
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#F6F6F6',
        borderRadius: pt(32),
        paddingHorizontal: pt(22)
    },
    m_itemBoxChoosed: {
        backgroundColor: 'rgba(255,245,246,1)',
        borderColor: '#FA2C19'
    },
    m_icon: {
        width: pt(40),
        height: pt(40),
        marginRight: pt(10)
    },
    m_itemText: {
        textAlign: 'center',
        fontSize: pt(24),
        color: '#262626'
    },
    m_itemTextChoosed: {
        color: '#FA2C19'
    },
    m_disabled: {
        color: '#ffffff'
    },
    titleBox: {
        paddingHorizontal: pt(32),
        paddingBottom: pt(22)
    },
    titleText: {
        fontSize: pt(28),
        color: '#858687'
    }
});
